import { createSelector } from 'reselect';

const getRouterState = (state) => state.router;

export const routerSelector = createSelector([getRouterState], (router) => router);
